import React from 'react'

import { i18n } from '~/i18n'

export type LogoStyles = 'black_on_white' | 'white_on_solid'

type Props = {
  className?: string
  type: LogoStyles
}

const AffirmLogo = (props: Props) => {
  const SOURCE_URL_MAP = {
    black_on_white: i18n.t('components.affirm_logo.black_on_white_url'),
    white_on_solid: i18n.t('components.affirm_logo.white_on_solid_url'),
  }

  return (
    <img
      className={props.className}
      src={SOURCE_URL_MAP[props.type]}
      alt={i18n.t('components.affirm_logo.alt')}
      data-testid="affirm-logo"
    />
  )
}

export default AffirmLogo
